import { DeleteCard } from '../../../store/actions';

import * as storymapStoreModule from '../../../store';
import { CardType, MoveActivityToTrash, MoveSubtaskToTrash, MoveTaskToTrash, MoveUnscheduledSubtaskToTrash } from '..';
import { getCardType } from './use';
import { getCardById, isActivity, isSubtask, isTask } from '../../../store/use';
import { uuid } from '@/_core/utils/uuid';
import { BoardUserActivityType } from '@/api/workspaceSettings/queries';

export const CreateTrashCardCommand = async (action: DeleteCard) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = getCardById(action.cardId);
    const cardType = getCardType(card);

    const activityId = await uuid.create();

    const boardActivity: any = {
        CardId: card.id,
        CardName: card.title,
        CardColor: card.color,
        Datetime: new Date().toJSON(),
        CardDescription: '',
        Content: JSON.stringify({
            version: 1,
            kind: 'delete',
            cardKey: card.key || '',
        }),
        EstimationUnit: '',
        OriginalContent: card.title,
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: getActivityType(cardType),
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    let cmd: MoveUnscheduledSubtaskToTrash | MoveSubtaskToTrash | MoveTaskToTrash | MoveActivityToTrash;

    if (isActivity(card)) {
        cmd = new MoveActivityToTrash(card.id, state.id);
    }
    if (isTask(card)) {
        cmd = new MoveTaskToTrash(card.id, state.id, card.activityId);

        const parent = state.activities.find((x) => x.id === card.activityId);

        boardActivity.ParentCardId = card.activityId;
        boardActivity.ParentCardName = parent.title;
    }
    if (isSubtask(card)) {
        if (card.releaseId) {
            cmd = new MoveSubtaskToTrash(card.id, state.id, card.taskId, card.releaseId);

            const release = state.releases.find((x) => x.id === card.releaseId);

            boardActivity.ReleaseId = card.releaseId;
            boardActivity.ReleaseName = release.name;
        } else {
            cmd = new MoveUnscheduledSubtaskToTrash(card.id, state.id, card.taskId);
        }
    }

    cmd.BoardActivity = boardActivity;

    return cmd;
};

const getActivityType = (cardType: CardType) => {
    switch (cardType) {
        case CardType.Activity:
            return BoardUserActivityType.ActivityDeleted;
        case CardType.Task:
            return BoardUserActivityType.TaskDeleted;
        case CardType.Subtask:
            return BoardUserActivityType.SubtaskDeleted;
        case CardType.UnscheduledSubtask:
            return BoardUserActivityType.UnscheduledSubtaskDeleted;
    }
};
